<template>
  <img src="/images/lower-back.png">
</template>

<script>
export default {
  name: "LowerBack"
}
</script>
